export default function IconBlog() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M2.5 1A1.5 1.5 0 0 0 1 2.5v10A1.5 1.5 0 0 0 2.5 14h8a1.5 1.5 0 0 0 1.5-1.5V11h1.5a1.5 1.5 0 0 0 1.5-1.5V4a1 1 0 0 0-1-1H13v-.5A1.5 1.5 0 0 0 11.5 1zm10.5 3h1v5.5a.5.5 0 0 1-.5.5H13zm-1 8.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5zM4 4h6v1H4zm0 3h6v1H4zm0 3h4v1H4z"
      />
    </svg>
  );
}
